import { BaseButton } from '@/shared/components'
import { Check, Copy } from 'lucide-react'
import { useState } from 'react'

type BaseCopyButtonProps = {
  text: string
  color?: 'primary' | 'secondary'
  size?: 'mini' | 'base'
}

export const BaseCopyButton = ({
  text,
  color = 'secondary',
  size = 'base',
}: BaseCopyButtonProps) => {
  const [copied, setCopied] = useState(false)
  const sizeClasses = size === 'base' ? 'h-5 w-5' : 'h-4 w-4'
  const colorClasses =
    color === 'primary' ? 'text-primary dark:text-primary-dark' : 'text-text-secondary'

  const iconClasses = `${sizeClasses} ${colorClasses}`

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (err) {
      console.error('Ошибка копирования:', err)
    }
  }

  return (
    <BaseButton onClick={handleCopy} variant="ghost" size="default" padding="empty">
      {copied ? <Check className={iconClasses} /> : <Copy className={iconClasses} />}
    </BaseButton>
  )
}
